module.exports = __webpack_public_path__ + "static/img/news4.73ce66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news4.png
// module id = PQKP
// module chunks = 52